import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";

import HeaderLogo from "#page-package/header-logo.tsx";

type Props = {
    // Modifies logo color depending on the header background color
    backgroundColor: "white" | "darkBlue";
};

/**
 * SimplifiedPageHeader is a replacement for the global page header, with fewer
 * visual distractions and ways to get lost, but still maintaining the logo for
 * basic layout consistency!
 *
 * To use, configure <PageDisplay /> to hide the usual page header, then insert
 * <SimplifiedPageHeader /> at the top of your page content.
 */
function SimplifiedPageHeader({backgroundColor}: Props): React.ReactElement {
    return (
        <View style={styles.simplifiedPageHeader}>
            <HeaderLogo backgroundColor={backgroundColor} />
        </View>
    );
}

const styles = StyleSheet.create({
    simplifiedPageHeader: {
        alignItems: "center",
        justifyContent: "center",
        minHeight: 60,
    },
});

export default SimplifiedPageHeader;
